import { SchemaClause } from '@amzn/awscat-portfolio-assessment-types';

import { constants } from '../../common/Localization';
import { Operator } from './interfaces';

export const actionItems = [
    {text: constants.ADD_NEW_RULE, id: 'addNewRule'},
    {text: constants.IMPORT_RULES, id: 'copyRules'}, //copies rule from another portfolio
    {text: constants.DELETE_RULE, id: 'deleteRule', disabled: true},
    {text: constants.DISABLE_RULE, id: 'disableRules', disabled: true},
    {text: constants.ENABLE_RULE, id: 'enableRules', disabled: true},
    {text: constants.DOWNLOAD_REPORT, id: 'download'},
    {text: constants.REVALIDATE, id: 'revalidate'},
];

export const impactOptions = [
    { label: constants.TCO, id: 'tco', value: 'tco' },
    { label: constants.MIGRATION_COST, id: 'migrationCost', value: 'migrationCost' },
    { label: constants.STRATEGY, id: 'strategy', value: 'strategy' },
    { label: constants.PLANNING, id: 'planning', value: 'planning' },
];

export const severityOptions = [
    { label: constants.HIGH, value: 'high' },
    { label: constants.MEDIUM_UPPERCASE, value: 'medium' },
    { label: constants.LOW, value: 'low' },
];

export const defaultSeverityOption = severityOptions[0];

export const severityFilterAnyOption = {
    label: constants.ANY_SEVERITY, value: 'any'
};

export const severityFilterUnspecifiedOption = {
    label: constants.NA, value: 'unspecified'
};

export const severityDefault = 'low';
export const severitySortOrder = ['low','medium','high'];

export const groupItems = [
    { label: '(', id: '(', value: '(' },
    { label: ')',  id: ')', value: ')' },
    { label: constants.AND_UPPERCASE, id: 'and', value: 'and' },
    { label: constants.OR, id: 'or', value: 'or' },
    { label: '-', id: 'null', value: 'null'},
];
export const operators: Operator = {
    strings: [
        { label: constants.MATCHES_REGULAR_EXPRESSION, id: 'Match regular expression', value: 'Match regular expression'},
        { label: constants.CONTAINS, id: 'Contains', value: 'Contains' },
        { label: constants.DOES_NOT_CONTAIN, id: 'Does Not Contain', value: 'Does Not Contain' },
        { label: constants.EXISTS, id: 'Exists', value: 'Exists', noValue: true },
        { label: constants.DOES_NOT_EXIST, id: 'Does Not Exist', value: 'Does Not Exist', noValue: true },
        { label: constants.IN, id: 'In', value: 'In' },
        { label: constants.NOT_IN, id: 'Not In', value: 'Not In' }
    ],
    numbers: [
        { label: '=', id: 'Equals', value: 'Equals' },
        { label: '≠', id: 'Does Not Equal', value: 'Does Not Equal' },
        { label: '>', id: 'Greater Than', value: 'Greater Than' },
        { label: '>=', id: 'Greater Than or Equal To', value: 'Greater Than or Equal To' },
        { label: '<', id: 'Less Than', value: 'Less Than' },
        { label: '<=', id: 'Less Than or Equal To', value: 'Less Than or Equal To' },
        { label: constants.EVEN, id: 'Even', value: 'Even', noValue: true },
        { label: constants.ODD, id: 'Odd', value: 'Odd', noValue: true },
        { label: constants.EXISTS, id: 'Exists', value: 'Exists', noValue: true },
        { label: constants.DOES_NOT_EXIST, id: 'Does Not Exist', value: 'Does Not Exist', noValue: true },
        { label: constants.IN, id: 'In', value: 'In' },
        { label: constants.NOT_IN, id: 'Not In', value: 'Not In' }
    ]
};

export const emptySchemaClause: SchemaClause = {
    firstGroup: null,
    attributeType: null,
    attribute: null,
    operator: null,
    value: null,
    secondGroup: null
};
